module.exports = __webpack_public_path__ + "img/icon-subscribe.e5b21e79.svg";